var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconQuotations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-quotations_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-quotations_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-quotations_svg__st0",
    d: "M18.4 23H5.6c-1.6 0-2.9-1.3-2.9-2.9V3.9C2.8 2.3 4.1 1 5.6 1h9.8c.6 0 1.3.2 1.8.6l2.9 2.3c.7.5 1.1 1.4 1.1 2.3v14c0 1.5-1.2 2.8-2.8 2.8zM5.6 3c-.4 0-.8.4-.8.9v16.2c0 .5.4.9.9.9h12.7c.5 0 .9-.4.9-.9v-14c0-.3-.1-.5-.3-.7l-3-2.2c-.2-.1-.4-.2-.6-.2H5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-quotations_svg__st0",
    d: "M17 9.3h-3.2c-.6 0-1-.4-1-1V5.1c0-.6.4-1 1-1s1 .4 1 1v2.2H17c.6 0 1 .4 1 1s-.5 1-1 1z",
    opacity: 0.5
  })));
}

export default SvgIconQuotations;